import React from "react";

const StatusMessages = ({ moduleName, status, count }) => {
  // Helper functions for text formatting
  const getModuleText = () => {
    const singular = moduleName.toLowerCase();
    return count > 1 ? `${singular}s` : singular;
  };

  const getCapitalizedModule = () => {
    return (
      moduleName.charAt(0).toUpperCase() + moduleName.slice(1).toLowerCase()
    );
  };

  const getPluralModule = () => {
    const capitalized = getCapitalizedModule();
    return count > 1 ? `${capitalized}s` : capitalized;
  };

  // Message templates
  const getMessages = () => {
    const moduleText = getModuleText();
    const pluralModule = getPluralModule();
    const isPlural = count > 1;

    // Create simple data objects with direct values
    const moduleValue = isPlural ? pluralModule : getCapitalizedModule();
    const moduleTextValue = moduleText;

    const templates = {
      active: {
        title: isPlural ? "reactivate_selected_modules" : "reactivate_module",
        titleData: { module: moduleValue },

        message: isPlural
          ? "reactivate_multiple_message"
          : "reactivate_single_message",
        messageData: {
          count: count,
          moduleText: moduleTextValue,
        },

        button: "reactivate_button",

        confirmTitle: isPlural ? "modules_reactivated" : "module_reactivated",
        confirmTitleData: { module: moduleValue },

        confirmMessage: isPlural
          ? "multiple_reactivated_confirmation"
          : "single_reactivated_confirmation",
        confirmMessageData: {
          count: count,
          moduleText: moduleTextValue,
        },
      },
      inactive: {
        title: isPlural ? "deactivate_selected_modules" : "deactivate_module",
        titleData: { module: moduleValue },

        message: isPlural
          ? "deactivate_multiple_message"
          : "deactivate_single_message",
        messageData: {
          count: count,
          moduleText: moduleTextValue,
        },

        button: "deactivate_button",

        confirmTitle: isPlural ? "modules_deactivated" : "module_deactivated",
        confirmTitleData: { module: moduleValue },

        confirmMessage: isPlural
          ? "multiple_deactivated_confirmation"
          : "single_deactivated_confirmation",
        confirmMessageData: {
          count: count,
          moduleText: moduleTextValue,
        },
      },
      delete: {
        title: isPlural ? "delete_selected_modules" : "delete_module",
        titleData: { module: moduleValue },

        message: isPlural ? "delete_multiple_message" : "delete_single_message",
        messageData: {
          count: count,
          moduleText: moduleTextValue,
        },

        button: "delete_button",

        confirmTitle: isPlural ? "modules_deleted" : "module_deleted",
        confirmTitleData: { module: moduleValue },

        confirmMessage: isPlural
          ? "multiple_deleted_confirmation"
          : "single_deleted_confirmation",
        confirmMessageData: {
          count: count,
          moduleText: moduleTextValue,
        },
      },
      draft: {
        title: isPlural ? "clear_selected_drafts" : "clear_draft",
        titleData: { module: moduleValue },

        message: isPlural
          ? "clear_multiple_drafts_message"
          : "clear_single_draft_message",
        messageData: {
          count: count,
          moduleText: moduleTextValue,
        },

        button: "clear_draft_button",

        confirmTitle: isPlural ? "drafts_cleared" : "draft_cleared",
        confirmTitleData: { module: moduleValue },

        confirmMessage: isPlural
          ? "multiple_drafts_cleared_confirmation"
          : "single_draft_cleared_confirmation",
        confirmMessageData: {
          count: count,
          moduleText: moduleTextValue,
        },
      },
    };

    return templates[status] || {};
  };

  // Return the messages object
  return getMessages();
};

export default StatusMessages;
